import { Notify } from "./function-call";
var stdin_default = Notify;
export { Notify, stdin_default as default };